// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/hero_image.webp", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Hero_hero__zvVCj {
  position: relative;
  padding: 160px 0;
  overflow: hidden;
}
.Hero_hero__zvVCj::before {
  content: '';
  position: absolute;
  right: -25%;
  bottom: 10%;
  width: 55vw;
  height: 55vw;
  border-radius: 99%;
  max-width: 1000px;
  max-height: 1000px;
  background: radial-gradient(circle, rgba(204, 151, 244, 0.64) 0%, rgba(114, 43, 255, 0.8) 35%, rgba(5, 5, 24, 0.8) 100%);
  z-index: -1;
  pointer-events: none;
  filter: blur(40px);
}

.Hero_container__-s7wo {
  display: flex;
  align-items: space-between;
  justify-content: space-between;
  gap: 20px;
  position: relative;
  z-index: 1;
  max-width: 90%;
  margin: 0 auto;
  overflow: hidden;
}

.Hero_content__YK9OZ {
  text-align: left;
  max-width: 800px;
}

.Hero_title__rL9MQ {
  font-size: 4rem;
  margin-bottom: 1.5rem;
  line-height: 1.2;
  color: #fff;
}

.Hero_subtitle__8Mcc5 {
  font-size: 1.25rem;
  color: var(--text-secondary);
  margin-bottom: 2.5rem;
}

.Hero_cta__3oEx8 {
  display: flex;
  gap: 1rem;
  justify-content: left;
}

.Hero_diceWrapper__PLfgn {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.Hero_heroBackground__DdyN2 {
  position: absolute;
  width: 100%;
  height: 100%;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  z-index: 1;
}

.Hero_dice__6Sbyq {
  width: 300px;
  height: 300px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  transform-style: preserve-3d;
  transition: transform 0.5s;
  z-index: 2;
}

.Hero_diceFace__WgKNF {
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--text);
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 30px;
  box-shadow: 0 0 30px rgba(114, 43, 255, 0.2);
}

.Hero_front__4fxIf {
  transform: translateZ(150px);
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
  background: rgba(255, 255, 255, 0.05);
}

.Hero_back__SlkVb {
  transform: rotateY(180deg) translateZ(150px);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  background: rgba(255, 255, 255, 0.05);
}

.Hero_right__BRKZN {
  transform: rotateY(90deg) translateZ(150px);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  background: rgba(255, 255, 255, 0.05);
}

.Hero_left__aDgJ6 {
  transform: rotateY(-90deg) translateZ(150px);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  background: rgba(255, 255, 255, 0.05);
}

.Hero_top__7Ermn {
  transform: rotateX(90deg) translateZ(150px);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  background: rgba(255, 255, 255, 0.05);
}

.Hero_bottom__\\+Gz0- {
  transform: rotateX(-90deg) translateZ(150px);
  backdrop-filter: blur(30px);
  -webkit-backdrop-filter: blur(30px);
  background: rgba(255, 255, 255, 0.05);
}

.Hero_dot__oCJ4V {
  position: absolute;
  width: 16%;
  height: 16%;
  border-radius: 50%;
  background: var(--text);
  box-shadow: inset 0 0 8px rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease;
}

.Hero_front__4fxIf .Hero_dot__oCJ4V {
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.Hero_back__SlkVb .Hero_dot__oCJ4V:nth-child(1) {
  left: 25%;
  top: 25%;
  transform: translate(-50%, -50%);
}
.Hero_back__SlkVb .Hero_dot__oCJ4V:nth-child(2) {
  left: 75%;
  top: 75%;
  transform: translate(-50%, -50%);
}

.Hero_right__BRKZN .Hero_dot__oCJ4V:nth-child(1) {
  left: 25%;
  top: 25%;
  transform: translate(-50%, -50%);
}
.Hero_right__BRKZN .Hero_dot__oCJ4V:nth-child(2) {
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.Hero_right__BRKZN .Hero_dot__oCJ4V:nth-child(3) {
  left: 75%;
  top: 75%;
  transform: translate(-50%, -50%);
}

.Hero_left__aDgJ6 .Hero_dot__oCJ4V:nth-child(1) {
  left: 25%;
  top: 25%;
  transform: translate(-50%, -50%);
}
.Hero_left__aDgJ6 .Hero_dot__oCJ4V:nth-child(2) {
  left: 75%;
  top: 25%;
  transform: translate(-50%, -50%);
}
.Hero_left__aDgJ6 .Hero_dot__oCJ4V:nth-child(3) {
  left: 25%;
  top: 75%;
  transform: translate(-50%, -50%);
}
.Hero_left__aDgJ6 .Hero_dot__oCJ4V:nth-child(4) {
  left: 75%;
  top: 75%;
  transform: translate(-50%, -50%);
}

.Hero_top__7Ermn .Hero_dot__oCJ4V:nth-child(1) {
  left: 25%;
  top: 25%;
  transform: translate(-50%, -50%);
}
.Hero_top__7Ermn .Hero_dot__oCJ4V:nth-child(2) {
  left: 75%;
  top: 25%;
  transform: translate(-50%, -50%);
}
.Hero_top__7Ermn .Hero_dot__oCJ4V:nth-child(3) {
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.Hero_top__7Ermn .Hero_dot__oCJ4V:nth-child(4) {
  left: 25%;
  top: 75%;
  transform: translate(-50%, -50%);
}
.Hero_top__7Ermn .Hero_dot__oCJ4V:nth-child(5) {
  left: 75%;
  top: 75%;
  transform: translate(-50%, -50%);
}

.Hero_bottom__\\+Gz0- .Hero_dot__oCJ4V:nth-child(1) {
  left: 25%;
  top: 25%;
  transform: translate(-50%, -50%);
}
.Hero_bottom__\\+Gz0- .Hero_dot__oCJ4V:nth-child(2) {
  left: 75%;
  top: 25%;
  transform: translate(-50%, -50%);
}
.Hero_bottom__\\+Gz0- .Hero_dot__oCJ4V:nth-child(3) {
  left: 25%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.Hero_bottom__\\+Gz0- .Hero_dot__oCJ4V:nth-child(4) {
  left: 75%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.Hero_bottom__\\+Gz0- .Hero_dot__oCJ4V:nth-child(5) {
  left: 25%;
  top: 75%;
  transform: translate(-50%, -50%);
}
.Hero_bottom__\\+Gz0- .Hero_dot__oCJ4V:nth-child(6) {
  left: 75%;
  top: 75%;
  transform: translate(-50%, -50%);
}

.Hero_diceFace__WgKNF:hover .Hero_dot__oCJ4V {
  background: #fff;
  box-shadow: 
    inset 0 0 8px rgba(0, 0, 0, 0.3),
    0 0 12px rgba(255, 255, 255, 0.5);
}

@media (max-width: 1024px) {
  .Hero_container__-s7wo {
    flex-direction: column;
  }
  .Hero_title__rL9MQ {
    font-size: 3rem;
  }

  .Hero_diceWrapper__PLfgn {
    height: 500px;
  }

  .Hero_dice__6Sbyq {
    width: 250px;
    height: 250px;
  }

  .Hero_front__4fxIf  { transform: translateZ(125px); }
  .Hero_back__SlkVb   { transform: rotateY(180deg) translateZ(125px); }
  .Hero_right__BRKZN  { transform: rotateY(90deg) translateZ(125px); }
  .Hero_left__aDgJ6   { transform: rotateY(-90deg) translateZ(125px); }
  .Hero_top__7Ermn    { transform: rotateX(90deg) translateZ(125px); }
  .Hero_bottom__\\+Gz0- { transform: rotateX(-90deg) translateZ(125px); }
}

@media (max-width: 768px) {
  .Hero_hero__zvVCj {
    padding-top: 120px;
    padding-bottom: 60px;
  }

  .Hero_container__-s7wo {
    gap: 4rem;
  }

  .Hero_title__rL9MQ {
    font-size: 2.5rem;
  }
  
  .Hero_subtitle__8Mcc5 {
    font-size: 1rem;
  }
  
  .Hero_cta__3oEx8 {
    flex-direction: column;
  }

  .Hero_diceWrapper__PLfgn {
    height: 400px;
  }

  .Hero_dice__6Sbyq {
    width: 200px;
    height: 200px;
  }

  .Hero_front__4fxIf  { transform: translateZ(100px); }
  .Hero_back__SlkVb   { transform: rotateY(180deg) translateZ(100px); }
  .Hero_right__BRKZN  { transform: rotateY(90deg) translateZ(100px); }
  .Hero_left__aDgJ6   { transform: rotateY(-90deg) translateZ(100px); }
  .Hero_top__7Ermn    { transform: rotateX(90deg) translateZ(100px); }
  .Hero_bottom__\\+Gz0- { transform: rotateX(-90deg) translateZ(100px); }

  .Hero_dot__oCJ4V {
    width: 20%;
    height: 20%;
  }
} `, "",{"version":3,"sources":["webpack://./src/components/Hero/Hero.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,wHAAwH;EACxH,WAAW;EACX,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,yDAAiD;EACjD,wBAAwB;EACxB,2BAA2B;EAC3B,4BAA4B;EAC5B,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gCAAgC;EAChC,4BAA4B;EAC5B,0BAA0B;EAC1B,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,qCAAqC;EACrC,0CAA0C;EAC1C,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;EAC1B,kCAAkC;EAClC,qCAAqC;AACvC;;AAEA;EACE,4CAA4C;EAC5C,2BAA2B;EAC3B,mCAAmC;EACnC,qCAAqC;AACvC;;AAEA;EACE,2CAA2C;EAC3C,2BAA2B;EAC3B,mCAAmC;EACnC,qCAAqC;AACvC;;AAEA;EACE,4CAA4C;EAC5C,2BAA2B;EAC3B,mCAAmC;EACnC,qCAAqC;AACvC;;AAEA;EACE,2CAA2C;EAC3C,2BAA2B;EAC3B,mCAAmC;EACnC,qCAAqC;AACvC;;AAEA;EACE,4CAA4C;EAC5C,2BAA2B;EAC3B,mCAAmC;EACnC,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,uBAAuB;EACvB,4CAA4C;EAC5C,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,QAAQ;EACR,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,QAAQ;EACR,gCAAgC;AAClC;AACA;EACE,SAAS;EACT,QAAQ;EACR,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,QAAQ;EACR,gCAAgC;AAClC;AACA;EACE,SAAS;EACT,QAAQ;EACR,gCAAgC;AAClC;AACA;EACE,SAAS;EACT,QAAQ;EACR,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,QAAQ;EACR,gCAAgC;AAClC;AACA;EACE,SAAS;EACT,QAAQ;EACR,gCAAgC;AAClC;AACA;EACE,SAAS;EACT,QAAQ;EACR,gCAAgC;AAClC;AACA;EACE,SAAS;EACT,QAAQ;EACR,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,QAAQ;EACR,gCAAgC;AAClC;AACA;EACE,SAAS;EACT,QAAQ;EACR,gCAAgC;AAClC;AACA;EACE,SAAS;EACT,QAAQ;EACR,gCAAgC;AAClC;AACA;EACE,SAAS;EACT,QAAQ;EACR,gCAAgC;AAClC;AACA;EACE,SAAS;EACT,QAAQ;EACR,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,QAAQ;EACR,gCAAgC;AAClC;AACA;EACE,SAAS;EACT,QAAQ;EACR,gCAAgC;AAClC;AACA;EACE,SAAS;EACT,QAAQ;EACR,gCAAgC;AAClC;AACA;EACE,SAAS;EACT,QAAQ;EACR,gCAAgC;AAClC;AACA;EACE,SAAS;EACT,QAAQ;EACR,gCAAgC;AAClC;AACA;EACE,SAAS;EACT,QAAQ;EACR,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB;;qCAEmC;AACrC;;AAEA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA,sBAAU,4BAA4B,EAAE;EACxC,sBAAU,4CAA4C,EAAE;EACxD,sBAAU,2CAA2C,EAAE;EACvD,sBAAU,4CAA4C,EAAE;EACxD,sBAAU,2CAA2C,EAAE;EACvD,uBAAU,4CAA4C,EAAE;AAC1D;;AAEA;EACE;IACE,kBAAkB;IAClB,oBAAoB;EACtB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA,sBAAU,4BAA4B,EAAE;EACxC,sBAAU,4CAA4C,EAAE;EACxD,sBAAU,2CAA2C,EAAE;EACvD,sBAAU,4CAA4C,EAAE;EACxD,sBAAU,2CAA2C,EAAE;EACvD,uBAAU,4CAA4C,EAAE;;EAExD;IACE,UAAU;IACV,WAAW;EACb;AACF","sourcesContent":[".hero {\n  position: relative;\n  padding: 160px 0;\n  overflow: hidden;\n}\n.hero::before {\n  content: '';\n  position: absolute;\n  right: -25%;\n  bottom: 10%;\n  width: 55vw;\n  height: 55vw;\n  border-radius: 99%;\n  max-width: 1000px;\n  max-height: 1000px;\n  background: radial-gradient(circle, rgba(204, 151, 244, 0.64) 0%, rgba(114, 43, 255, 0.8) 35%, rgba(5, 5, 24, 0.8) 100%);\n  z-index: -1;\n  pointer-events: none;\n  filter: blur(40px);\n}\n\n.container {\n  display: flex;\n  align-items: space-between;\n  justify-content: space-between;\n  gap: 20px;\n  position: relative;\n  z-index: 1;\n  max-width: 90%;\n  margin: 0 auto;\n  overflow: hidden;\n}\n\n.content {\n  text-align: left;\n  max-width: 800px;\n}\n\n.title {\n  font-size: 4rem;\n  margin-bottom: 1.5rem;\n  line-height: 1.2;\n  color: #fff;\n}\n\n.subtitle {\n  font-size: 1.25rem;\n  color: var(--text-secondary);\n  margin-bottom: 2.5rem;\n}\n\n.cta {\n  display: flex;\n  gap: 1rem;\n  justify-content: left;\n}\n\n.diceWrapper {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n}\n\n.heroBackground {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  background-image: url('./assets/hero_image.webp');\n  background-size: contain;\n  background-position: center;\n  background-repeat: no-repeat;\n  z-index: 1;\n}\n\n.dice {\n  width: 300px;\n  height: 300px;\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  transform-style: preserve-3d;\n  transition: transform 0.5s;\n  z-index: 2;\n}\n\n.diceFace {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--text);\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  border-radius: 30px;\n  box-shadow: 0 0 30px rgba(114, 43, 255, 0.2);\n}\n\n.front {\n  transform: translateZ(150px);\n  backdrop-filter: blur(5px);\n  -webkit-backdrop-filter: blur(5px);\n  background: rgba(255, 255, 255, 0.05);\n}\n\n.back {\n  transform: rotateY(180deg) translateZ(150px);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  background: rgba(255, 255, 255, 0.05);\n}\n\n.right {\n  transform: rotateY(90deg) translateZ(150px);\n  backdrop-filter: blur(20px);\n  -webkit-backdrop-filter: blur(20px);\n  background: rgba(255, 255, 255, 0.05);\n}\n\n.left {\n  transform: rotateY(-90deg) translateZ(150px);\n  backdrop-filter: blur(20px);\n  -webkit-backdrop-filter: blur(20px);\n  background: rgba(255, 255, 255, 0.05);\n}\n\n.top {\n  transform: rotateX(90deg) translateZ(150px);\n  backdrop-filter: blur(20px);\n  -webkit-backdrop-filter: blur(20px);\n  background: rgba(255, 255, 255, 0.05);\n}\n\n.bottom {\n  transform: rotateX(-90deg) translateZ(150px);\n  backdrop-filter: blur(30px);\n  -webkit-backdrop-filter: blur(30px);\n  background: rgba(255, 255, 255, 0.05);\n}\n\n.dot {\n  position: absolute;\n  width: 16%;\n  height: 16%;\n  border-radius: 50%;\n  background: var(--text);\n  box-shadow: inset 0 0 8px rgba(0, 0, 0, 0.2);\n  transition: all 0.3s ease;\n}\n\n.front .dot {\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n}\n\n.back .dot:nth-child(1) {\n  left: 25%;\n  top: 25%;\n  transform: translate(-50%, -50%);\n}\n.back .dot:nth-child(2) {\n  left: 75%;\n  top: 75%;\n  transform: translate(-50%, -50%);\n}\n\n.right .dot:nth-child(1) {\n  left: 25%;\n  top: 25%;\n  transform: translate(-50%, -50%);\n}\n.right .dot:nth-child(2) {\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n}\n.right .dot:nth-child(3) {\n  left: 75%;\n  top: 75%;\n  transform: translate(-50%, -50%);\n}\n\n.left .dot:nth-child(1) {\n  left: 25%;\n  top: 25%;\n  transform: translate(-50%, -50%);\n}\n.left .dot:nth-child(2) {\n  left: 75%;\n  top: 25%;\n  transform: translate(-50%, -50%);\n}\n.left .dot:nth-child(3) {\n  left: 25%;\n  top: 75%;\n  transform: translate(-50%, -50%);\n}\n.left .dot:nth-child(4) {\n  left: 75%;\n  top: 75%;\n  transform: translate(-50%, -50%);\n}\n\n.top .dot:nth-child(1) {\n  left: 25%;\n  top: 25%;\n  transform: translate(-50%, -50%);\n}\n.top .dot:nth-child(2) {\n  left: 75%;\n  top: 25%;\n  transform: translate(-50%, -50%);\n}\n.top .dot:nth-child(3) {\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n}\n.top .dot:nth-child(4) {\n  left: 25%;\n  top: 75%;\n  transform: translate(-50%, -50%);\n}\n.top .dot:nth-child(5) {\n  left: 75%;\n  top: 75%;\n  transform: translate(-50%, -50%);\n}\n\n.bottom .dot:nth-child(1) {\n  left: 25%;\n  top: 25%;\n  transform: translate(-50%, -50%);\n}\n.bottom .dot:nth-child(2) {\n  left: 75%;\n  top: 25%;\n  transform: translate(-50%, -50%);\n}\n.bottom .dot:nth-child(3) {\n  left: 25%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n}\n.bottom .dot:nth-child(4) {\n  left: 75%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n}\n.bottom .dot:nth-child(5) {\n  left: 25%;\n  top: 75%;\n  transform: translate(-50%, -50%);\n}\n.bottom .dot:nth-child(6) {\n  left: 75%;\n  top: 75%;\n  transform: translate(-50%, -50%);\n}\n\n.diceFace:hover .dot {\n  background: #fff;\n  box-shadow: \n    inset 0 0 8px rgba(0, 0, 0, 0.3),\n    0 0 12px rgba(255, 255, 255, 0.5);\n}\n\n@media (max-width: 1024px) {\n  .container {\n    flex-direction: column;\n  }\n  .title {\n    font-size: 3rem;\n  }\n\n  .diceWrapper {\n    height: 500px;\n  }\n\n  .dice {\n    width: 250px;\n    height: 250px;\n  }\n\n  .front  { transform: translateZ(125px); }\n  .back   { transform: rotateY(180deg) translateZ(125px); }\n  .right  { transform: rotateY(90deg) translateZ(125px); }\n  .left   { transform: rotateY(-90deg) translateZ(125px); }\n  .top    { transform: rotateX(90deg) translateZ(125px); }\n  .bottom { transform: rotateX(-90deg) translateZ(125px); }\n}\n\n@media (max-width: 768px) {\n  .hero {\n    padding-top: 120px;\n    padding-bottom: 60px;\n  }\n\n  .container {\n    gap: 4rem;\n  }\n\n  .title {\n    font-size: 2.5rem;\n  }\n  \n  .subtitle {\n    font-size: 1rem;\n  }\n  \n  .cta {\n    flex-direction: column;\n  }\n\n  .diceWrapper {\n    height: 400px;\n  }\n\n  .dice {\n    width: 200px;\n    height: 200px;\n  }\n\n  .front  { transform: translateZ(100px); }\n  .back   { transform: rotateY(180deg) translateZ(100px); }\n  .right  { transform: rotateY(90deg) translateZ(100px); }\n  .left   { transform: rotateY(-90deg) translateZ(100px); }\n  .top    { transform: rotateX(90deg) translateZ(100px); }\n  .bottom { transform: rotateX(-90deg) translateZ(100px); }\n\n  .dot {\n    width: 20%;\n    height: 20%;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"hero": `Hero_hero__zvVCj`,
	"container": `Hero_container__-s7wo`,
	"content": `Hero_content__YK9OZ`,
	"title": `Hero_title__rL9MQ`,
	"subtitle": `Hero_subtitle__8Mcc5`,
	"cta": `Hero_cta__3oEx8`,
	"diceWrapper": `Hero_diceWrapper__PLfgn`,
	"heroBackground": `Hero_heroBackground__DdyN2`,
	"dice": `Hero_dice__6Sbyq`,
	"diceFace": `Hero_diceFace__WgKNF`,
	"front": `Hero_front__4fxIf`,
	"back": `Hero_back__SlkVb`,
	"right": `Hero_right__BRKZN`,
	"left": `Hero_left__aDgJ6`,
	"top": `Hero_top__7Ermn`,
	"bottom": `Hero_bottom__+Gz0-`,
	"dot": `Hero_dot__oCJ4V`
};
export default ___CSS_LOADER_EXPORT___;
